// MAPEO TEMPORAL EN FRONT — candidato a mover al backend.
//
// El catálogo CYPE (/cype/search y /cype/item) devuelve un shape propio que NO
// coincide con el que espera NewModalPartida. Este módulo traduce uno al otro.
//
// PARA PEDIRLE AL BACK: que /cype/item devuelva la partida ya en el formato de
// abajo (o un `?format=planhopper`). Entonces este archivo entero se borra y en
// PartBrowser se pasa la respuesta directamente a newModalPart.setProperty().
// Lo que el back tendría que resolver por su lado:
//   1. Renombrar campos: shortDescription->name, longDescription->description,
//      unit->unity, unitPrice->price.
//   2. breakdown[] -> decomposition[], y dentro name->description, qty->quantity,
//      unit->unity, y `cost` (importe de línea) -> `price` (precio UNITARIO).
//   3. Traducir `type` de string español al enum int de Planhopper (ver TYPE_MAP).
//   4. Añadir los campos que el catálogo no tiene, a 0/""/[] (ver PARTIDA_DEFAULTS).

// El enum de decomposition.type en Planhopper:
// 0 coste · 1 manodeobra · 2 maquinaria · 3 material · 4 residuoAdicional · 5 residuoClasificacion
// Valores de `type` observados en la API (muestreo sobre resultados de "hormigon"):
// "Materiales", "Mano de obra", "Maquinaria y medios auxiliares", "Sin clasificar", "Desconocido".
// La lista no es exhaustiva: cualquier valor no contemplado cae a 0 (coste).
const TYPE_MAP = {
  Materiales: 3,
  "Mano de obra": 1,
  "Maquinaria y medios auxiliares": 2,
  "Sin clasificar": 0,
  Desconocido: 0,
}

const PARTIDA_DEFAULTS = {
  refPrice: 0,
  quantity: 0,
  clientPrice: 0,
  margin: 0,
  costeGeneral: 0,
  costeIndirecto: 0,
  industrialProfit: 0,
  comment: "",
  measures: [],
}

// `cost` que llega de CYPE es el IMPORTE de la línea (precio unitario x cantidad):
// la suma de todos los `cost` de un desglose da exactamente el `unitPrice` de la
// partida. `decomposition.price` en cambio es el precio UNITARIO, así que hay que
// deshacer la multiplicación. Las líneas "%" llegan con quantity = rendimiento y
// cost = base × rendimiento (scrap-cype#59), así que aquí sale el precio base; sólo si quantity es 0
// no se puede dividir: se deja el precio a 0.
const toUnitPrice = (cost, quantity) => {
  const qty = Number(quantity) || 0
  const amount = Number(cost) || 0
  if (qty === 0) return "0"
  return (amount / qty).toString()
}

const mapDecompositionLine = line => ({
  type: TYPE_MAP[line.type] ?? 0,
  description: line.name || "",
  quantity: (Number(line.quantity) || 0).toString(),
  unity: line.unit || "pa",
  price: toUnitPrice(line.cost, line.quantity),
})

const mapToPartida = item => {
  const decomposition = (item.breakdown || []).map(mapDecompositionLine)

  return {
    ...PARTIDA_DEFAULTS,
    code: item.code || "",
    name: item.shortDescription || "",
    description: item.longDescription || "",
    unity: item.unit || "pa",
    price: Number(item.unitPrice) || 0,
    decomposition,
  }
}

export { TYPE_MAP, mapToPartida }
export default mapToPartida
